import React from 'react'

function Icon({ width, height }) {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 269 35"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
    >
      <title>风险管控与隐患治理</title>
      <defs>
        <text
          id="text-1"
          fontFamily="SourceHanSansCN-Heavy, Source Han Sans CN"
          fontSize="28"
          fontWeight="600"
          letterSpacing="1.3"
          fill="#FFFFFF"
        >
          <tspan x="0" y="31">
            风险管控与隐患治理
          </tspan>
        </text>
        <filter
          x="-2.7%"
          y="-17.9%"
          width="105.3%"
          height="150.0%"
          filterUnits="objectBoundingBox"
          id="filter-2"
        >
          <feOffset
            dx="0"
            dy="2"
            in="SourceAlpha"
            result="shadowOffsetOuter1"
          ></feOffset>
          <feGaussianBlur
            stdDeviation="2"
            in="shadowOffsetOuter1"
            result="shadowBlurOuter1"
          ></feGaussianBlur>
          <feColorMatrix
            values="0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.208342439 0"
            type="matrix"
            in="shadowBlurOuter1"
          ></feColorMatrix>
        </filter>
      </defs>
      <g
        id="页面-2"
        stroke="none"
        strokeWidth="1"
        fill="none"
        fillRule="evenodd"
        fillOpacity="1"
      >
        <g
          id="风险管控与隐患治理-图集-缺陷"
          transform="translate(-21.000000, -17.000000)"
          fill="#FFFFFF"
        >
          <g
            id="风险管控与隐患治理"
            transform="translate(24.000000, 12.000000)"
          >
            <use filter="url(#filter-2)" xlinkHref="#text-1"></use>
            <use xlinkHref="#text-1"></use>
          </g>
        </g>
      </g>
    </svg>
  )
}

const GxdwIcon = (props) => {
  const { width = 20, height = 20 } = props
  return <Icon width={width} height={height} />
}

export default GxdwIcon
